import DisplayDensityMode from 'owa-service/lib/contract/DisplayDensityMode';

export default {
    DisplayDensityQuickSettings: {
        datapoint: {
            name: 'DisplayDensityQuickSettings',
            customData: (displayDensityMode: DisplayDensityMode) => [displayDensityMode],
        },
    },
    DisplayDensityFullSettings: {
        datapoint: {
            name: 'DisplayDensityFullSettings',
            customData: (displayDensityMode: DisplayDensityMode) => [displayDensityMode],
        },
    },
};
